import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { styled as muiStyled } from "@mui/material/styles";
import type { CreateCSSProperties } from "@mui/styles";

import type ColormapInterface from "shared-types/colormapinterface";
import { borderRadius, getSpacing, letterSpacing } from "stylesheetB2b";

const LIST_ITEM_HEIGHT_BAM = getSpacing(10);
const LIST_ITEM_DRAGGING_OUTLINE_WIDTH_IN_PX = 2;

export const StyledList = muiStyled(List)(() => ({
	padding: `${getSpacing(8)} 0`,
}));

export const StyledLastSongContainer = muiStyled(List)(() => ({
	paddingRight: getSpacing(4),
	paddingTop: 0,
	width: "100%",
}));

export const StyledListItem = muiStyled(ListItem)<{
	colors: ColormapInterface;
	selected?: boolean;
	highlighted?: boolean;
}>(({ colors, selected, highlighted }) => ({
	borderRadius: borderRadius.XLarge,
	backgroundColor: `${highlighted ? colors.highlightPoint : colors.waitingListSongBackground} !important`,
	height: LIST_ITEM_HEIGHT_BAM,
	marginBottom: getSpacing(2),
	paddingRight: getSpacing(2),
	paddingLeft: getSpacing(3),
	"&:hover": {
		backgroundColor: colors.waitingListSongBackground,
	},
	focusVisible: {
		backgroundColor: colors.waitingListSongBackground,
	},
	border: `solid ${selected ? colors.waitingListDraggingOutline : "none"}`,
}));

export const listItemDraggingStyle = (colors: ColormapInterface) => ({
	border: `solid ${LIST_ITEM_DRAGGING_OUTLINE_WIDTH_IN_PX}px ${colors.waitingListDraggingOutline}`,
});

export const textCommonStyle: CreateCSSProperties<object> = {
	letterSpacing: letterSpacing.normal,
	whiteSpace: "nowrap",
	textOverflow: "ellipsis",
	overflow: "hidden",
};
